/* CHINA DEPOT: shared query normalization for autocomplete and full search. */
(function(root){
  'use strict';
  const groups = [
    ['bocina',['bocina','bocinas','altavoz','altavoces','parlante','parlantes','speaker','speakers','sonido','音响','音箱','音響']],
    ['llanta',['llanta','llantas','neumatico','neumaticos','tire','tyre','轮胎','輪胎']],
    ['audifonos',['audifono','audifonos','auricular','auriculares','headphones','earphones','耳机','耳機']],
    ['microfono',['microfono','microfonos','microphone','麦克风','話筒','话筒']],
    ['bluetooth',['bluetooth','蓝牙','藍牙']],
    ['inalambrico',['inalambrico','inalambrica','inalambricos','inalambricas','wireless','无线','無線']],
    ['portatil',['portatil','portatiles','portable','便携','便攜']],
    ['bateria portatil',['power bank','powerbank','充电宝','行動電源','移动电源']],
    ['mouse',['mouse','raton','鼠标','滑鼠']],
    ['cable',['cable','cables','数据线','充电线','數據線']],
    ['soporte',['soporte','soportes','支架']],
    ['celular',['celular','telefono','手机','手機']],
    ['tablet',['tablet','平板']],
    ['laptop',['laptop','portatil ordenador','笔记本电脑','筆記本電腦']],
    ['ventilador',['ventilador','ventiladores','风扇','風扇']],
    ['linterna',['linterna','linternas','手电筒','手電筒']],
    ['labial',['labial','labiales','lipstick','pintalabios','口红','口紅']],
    ['brillo labios',['lip gloss','lipgloss','唇彩','唇蜜']],
    ['rubor',['rubor','rubores','blush','腮红','腮紅']],
    ['corrector',['corrector','concealer','遮瑕']],
    ['sombras',['sombras','eyeshadow','眼影']],
    ['mascara pestanas',['mascara de pestanas','mascara para pestanas','睫毛膏']],
    ['delineador',['delineador','eyeliner','眼线','眼線']],
    ['unas postizas',['unas postizas','fake nails','假指甲','美甲片','指甲贴','甲片']],
    ['brocha',['brocha','brochas','化妆刷','化妝刷']],
    ['crema',['crema','cremas','面霜','乳霜']],
    ['serum',['serum','精华液','精華液']],
    ['cabello',['cabello','pelo','头发','頭髮']],
    ['coletero',['coletero','coleteros','rizo','rizos','scrunchie','scrunchies','liga para cabello','ligas para cabello','liga de pelo','goma de pelo','hair tie','发圈','髮圈','头绳','皮筋']],
    ['pinza cabello',['发夹','髮夾']],
    ['peine',['peine','peines','梳子']],
    ['espejo',['espejo','espejos','镜子','鏡子']],
    ['taza',['taza','tazas','杯子','马克杯','馬克杯']],
    ['cuchillo',['cuchillo','cuchillos','菜刀','刀具']],
    ['cuchara',['cuchara','cucharas','勺子']],
    ['molde',['molde','moldes','模具']],
    ['organizador',['organizador','organizadores','收纳','收納']],
    ['mopa',['mopa','mopas','trapeador','拖把']],
    ['bolsa',['bolsa','bolsas','袋子']],
    ['mochila',['mochila','mochilas','背包','书包','書包']],
    ['peluche',['peluche','peluches','毛绒玩具','毛絨玩具','玩偶']],
    ['oso',['oso','osos','熊']],
    ['balon futbol',['pelota de futbol','balon de futbol','足球']],
    ['balon baloncesto',['basketball','basquetbol','篮球','籃球']],
    ['yoga',['yoga','瑜伽']],
    ['cuerda',['cuerda','cuerdas','跳绳','跳繩']],
    ['comedero',['comedero','comederos','宠物碗','狗碗','猫碗']],
    ['arnes',['arnes','arneses','宠物胸背','狗胸背']],
    ['correa',['correa','correas','牵引绳','牽引繩']],
    ['calculadora',['calculadora','calculadoras','计算器','計算器']],
    ['portalapices',['portalapices','笔筒','筆筒']],
    ['navidad',['navidad','navideno','navidena','christmas','圣诞','聖誕']],
    ['arbol',['arbol','arboles','pino navideno','christmas tree','圣诞树','聖誕樹']],
    ['papa noel',['santa claus','santa','papa noel','圣诞老人','聖誕老人']],
    ['rojo',['rojo','roja','red','红色','紅色']],
    ['azul',['azul','blue','蓝色','藍色']],
    ['negro',['negro','negra','black','黑色']],
    ['blanco',['blanco','blanca','white','白色']],
    ['rosado',['rosado','rosada','pink','粉色']],
  ];
  groups.push(
    ['pinza cabello',['pinza de pelo','pinzas de pelo','hair clip','pasador de cabello','发卡']],
    ['champu',['shampoo','champu','洗发水','洗髮水']],
    ['acondicionador',['acondicionador','护发素','護髮素']],
    ['jabon',['jabon','jabones','soap','香皂','肥皂']],
    ['protector solar',['protector solar','bloqueador','sunscreen','防晒','防曬']],
    ['peluche',['muneco de peluche','stuffed animal']],
    ['lampara',['lampara','lamparas','luz','luces','灯','燈']],
    ['juguete',['juguete','juguetes','toy','toys']],
    ['collar',['collar','collares','项圈','項圈']],
    ['pelota',['pelota','pelotas','ball','balon','balones','球']],
    ['taza',['mug','vaso','vasos']],
    ['cargador',['cargador','cargadores','charger','充电器']],
    ['cepillo',['cepillo','cepillos','刷子']],
    ['tijera',['tijera','tijeras','剪刀']],
    ['botella',['botella','botellas','水瓶']],
    ['termo',['termo','termos','保温杯']],
    ['cortina',['cortina','cortinas','窗帘']],
    ['guirnalda',['guirnalda','guirnaldas','花环']],
    ['dorado',['dorado','dorada','gold','金色']],
    ['plateado',['plateado','plateada','silver','银色']],
    ['rosado',['rosa','rosas','pink']]
  );
  const categories = {'美妆':['Maquillaje de Rostro','Maquillaje de Ojos','Labios','Uñas y Accesorios','Cuidado Facial'], '化妆品':['Maquillaje de Rostro','Maquillaje de Ojos','Labios'], '玩具':['Juguetes'], '宠物':['Mascotas'], '文具':['Papelería','Calculadoras'], '电子产品':['Electrónica'], '厨房用品':['Cocina'], '体育用品':['Deportes'], '家居':['Hogar y organización']};
  const normalize=s=>String(s||'').normalize('NFKC').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[‐‑–—−]/g,'-').replace(/\s+/g,' ').trim();
  const escapeRe=s=>s.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');
  const aliases=groups.flatMap(([to,from])=>from.map(x=>({from:normalize(x),to}))).sort((a,b)=>b.from.length-a.from.length);
  const stop=new Set(['de','del','la','las','el','los','para','con','en','y','un','una','the','a','of','for']);
  // Search concepts are alternatives, not destructive one-word substitutions.
  const term=(field,value)=>field+':"'+value.replace(/["\\]/g,'')+'"';
  const either=xs=>xs.length===1?xs[0]:'('+[...new Set(xs)].join(' OR ')+')';
  const variants={
    bocina:['bocina','altavoz','parlante'], audifonos:['audifonos','auriculares'],
    coletero:['coletero','liga','scrunchie'], arbol:['arbol','pino'],
    navidad:['navidad','navideno','navidena','navidenos','navidenas'],
    lampara:['lampara','luz','luces'], labial:['labial','lipstick','pintalabios'],
    inalambrico:['inalambrico','inalambrica'], negro:['negro','negra'],
    blanco:['blanco','blanca'], rojo:['rojo','roja'], rosado:['rosado','rosada','rosa'],
    dorado:['dorado','dorada'], plateado:['plateado','plateada'],
    champu:['champu','shampoo'], taza:['taza','vaso'], pelota:['pelota','balon'],
    cabello:['cabello','pelo'], juguete:['juguete','juguetes']
  };
  function clause(value){
    if(value==='pinza cabello')return '(title:"pinza" AND product_type:"Accesorios para el cabello")';
    if(value==='coletero')return '(title:"coletero" OR title:"scrunchie" OR (title:"liga" AND product_type:"Accesorios para el cabello"))';
    if(value==='navidad')return either([...variants.navidad.map(v=>term('title',v)),term('product_type','Navidad')]);
    return either((variants[value]||[value]).flatMap(v=>[term('title',v),term('tag',v),term('product_type',v)]));
  }
  function distance(a,b){
    let prev=Array.from({length:b.length+1},(_,i)=>i),older;
    for(let i=1;i<=a.length;i++){const row=[i];for(let j=1;j<=b.length;j++){row[j]=Math.min(row[j-1]+1,prev[j]+1,prev[j-1]+(a[i-1]===b[j-1]?0:1));if(older&&i>1&&j>1&&a[i-1]===b[j-2]&&a[i-2]===b[j-1])row[j]=Math.min(row[j],older[j-2]+1);}older=prev;prev=row;}return prev[b.length];
  }
  const vocabulary=root.CDSearchVocabulary||[];
  function correct(word){
    if(!/^[a-z]{4,}$/.test(word)||vocabulary.includes(word)||vocabulary.some(w=>w.startsWith(word)))return word;
    const near=vocabulary.filter(w=>w[0]===word[0]&&Math.abs(w.length-word.length)<=1&&distance(word,w)===1);
    return near.length===1?near[0]:word;
  }
  function resolve(raw){
    const original=String(raw||'').trim().slice(0,128),q=normalize(original);
    if(!q)return {query:'',label:original};
    if(/\b(?:title|tag|product_type|variants\.sku):/i.test(original))return {query:original,label:original};
    if(categories[q])return {query:either(categories[q].map(x=>term('product_type',x))),label:original};
    const sku=q.match(/^(?:sku\s*:?\s*)?(\d{4,6})\s*[- ]\s*(\d{1,4})$/);
    if(sku)return {query:term('variants.sku',sku[1]+'-'+sku[2]),label:original};
    const corrections=[];
    let working=q.replace(/[a-z]+/g,w=>{const c=correct(w);if(c!==w)corrections.push(c);return c;});
    const replacements=[];
    for(const a of aliases){
      const chinese=/[\u3400-\u9fff]/.test(a.from);
      const re=new RegExp(chinese?escapeRe(a.from):'(^|[^a-z0-9])('+escapeRe(a.from)+')(?=$|[^a-z0-9])','g');
      working=working.replace(re,(m,left)=>{const id=replacements.push(a.to)-1;return (chinese?'':left)+' ZZ'+id+'ZZ ';});
    }
    const parts=working.split(/\s+/).filter(x=>x&&!stop.has(x));
    const clauses=parts.map((word,index)=>{
      const m=word.match(/^ZZ(\d+)ZZ$/);if(m)return clause(replacements[Number(m[1])]);
      const clean=word.replace(/[^a-z0-9\u3400-\u9fff.-]/g,'');if(!clean)return '';
      // Prefix matching makes partial input useful without scanning product descriptions.
      const prefix=index===parts.length-1&&/^[a-z]{3,}$/.test(clean)&&!vocabulary.includes(clean);
      const completions=prefix?vocabulary.filter(w=>w.startsWith(clean)).slice(0,16):[];
      return completions.length?either(completions.map(clause)):clause(clean);
    }).filter(Boolean);
    return {query:[...new Set(clauses)].join(' AND '),label:original,corrections,concepts:replacements};
  }
  function score(title,raw){
    const text=normalize(title),q=normalize(raw),concepts=resolve(raw).concepts||[];
    const words=[...new Set([...q.split(/\s+/).filter(w=>w&&!stop.has(w)),...concepts.flatMap(c=>c.split(' '))])];
    let result=text.includes(q)?1000:0;
    for(const word of words){const index=text.indexOf(word);if(index>=0)result+=20+(index===0?10:0);}
    if(concepts.includes('arbol')&&/navidad|naviden/.test(text))result+=30;
    return result;
  }
  function related(raw){
    const r=resolve(raw),modifiers=new Set(['navidad','rojo','azul','blanco','negro','rosado','dorado','plateado','bluetooth','inalambrico','portatil','llanta','cabello']);
    const concepts=(r.concepts||[]).filter(x=>!modifiers.has(x));
    const core=groups.find(([key])=>concepts.includes(key));if(!core)return null;
    const label=core[1][0],query=resolve(label).query;return query===r.query?null:{query,label};
  }
  function url(raw,base){
    const r=resolve(raw);const u=new URL(base||'/search',root.location?.origin||'https://www.chinadepot-gt.com');
    u.searchParams.set('q',r.query);u.searchParams.set('type','product');u.searchParams.set('options[prefix]','last');u.searchParams.set('options[unavailable_products]','last');u.searchParams.set('sort_by','relevance');
    if(r.query!==r.label)u.searchParams.set('cd_q',r.label);
    return u;
  }
  function decorate(scope,raw){
    const label=raw||new URL(root.location.href).searchParams.get('cd_q');if(!label)return;
    scope.querySelectorAll('[data-cd-search-label]').forEach(e=>e.textContent=label);
    scope.querySelectorAll('a[href*="/search?"]').forEach(a=>{const u=new URL(a.href);if(u.searchParams.has('q')){u.searchParams.set('cd_q',label);a.href=u.href;}});
  }
  root.CDSearch={resolve,url,decorate,related,score};
  if(typeof module!=='undefined')module.exports=root.CDSearch;
  if(!root.document)return;
  function init(){
    const current=new URL(root.location.href);
    if(/\/search\/?$/.test(current.pathname)&&!current.searchParams.has('view')&&current.searchParams.get('q')){
      const raw=current.searchParams.get('q'),saved=current.searchParams.get('cd_q'),r=resolve(saved||raw);
      if(saved&&r.query!==raw){current.searchParams.set('q',r.query);root.location.replace(current.href);return;}
      if(!current.searchParams.has('cd_q')&&r.query!==raw){const next=url(raw,current.pathname);for(const [k,v] of current.searchParams)if(k.startsWith('filter.'))next.searchParams.append(k,v);root.location.replace(next.href);return;}
      const label=current.searchParams.get('cd_q');if(label){root.document.title=root.document.title.split(raw).join(label);root.document.querySelectorAll('form[action$="/search"] input[name="q"]').forEach(e=>e.value=label);decorate(root.document,label);}
    }
    if(root.CDSearchUI)root.CDSearchUI.init();
    root.document.addEventListener('submit',e=>{
      const f=e.target;if(!f.matches('form[action$="/search"]'))return;
      const input=f.querySelector('input[name="q"]');if(!input)return;
      e.preventDefault();e.stopImmediatePropagation();if(input.value.trim())root.location.assign(url(input.value,f.action).href);
    },true);
  }
  if(root.document.readyState==='loading')root.document.addEventListener('DOMContentLoaded',init);else init();
})(typeof window==='undefined'?globalThis:window);
